// @ts-nocheck
import genRequest from "includes/request";
import generateUUID from "includes/UUID";

// Answers reach the UI either as FormAnswerModel (value() method) or as raw
// objects built by the fillers (value field): read both the same way.
export const answerValue = (answer) =>
	typeof answer?.value === "function" ? answer.value() : answer?.value;

export default class FormAnswerModel {

	constructor(obj, parent) {

		this.parent = parent;
		this.optionId = (obj?.optionId || obj?.id || null);
		this.employeeId = (obj?.employeeId || null);
		this.questionId = (obj?.questionId || null);
		this._value = (obj?.value ?? "");
		this.isFreeAnswer = (obj?.isFreeAnswer ? obj.isFreeAnswer : true);
		this.isNumeric = (obj?.isNumeric || false);
		this.isBool = (obj?.isBool || false);
		this.isFile = (obj?.isFile || false);
		this.lastChanged = (obj?.lastChanged || null);
		this.lastChangedAuthorId = (obj?.lastChangedAuthorId || null);

		this.tempId = (obj?.tempId || generateUUID());
	}

	send() {
		let prom = new Promise((resolve, reject) => {
			this.sendAnswer()
				.then(() => {
					resolve (true);
				}, reject);
		});
		return (prom);
	}

	sendAnswer() {
		let that = this;
		let req = genRequest(
			( this.optionId && this.employeeId ?
				"forms/form-answers/employee/" + this.employeeId + "/option/" + this.optionId
				:
				"forms/form-answers"
			),
			this.values(),
			(this.optionId && this.employeeId ? "put" : "post")
		).then((resp) => {
			if (!that.employeeId)
				that.employeeId = resp.employeeId || resp.id;
		});
		return (req);
	}

	values() {
		let obj = {
			optionId: this.optionId,
			employeeId: this.employeeId,
			questionId: this.questionId,
			value: this._value,
			isFreeAnswer: this.isFreeAnswer,
			isNumeric: this.isNumeric,
			isBool: this.isBool,
			isFile: this.isFile,
			lastChanged: this.lastChanged,
			lastChangedAuthorId: this.lastChangedAuthorId
		};
		return (obj);
	}

	value(new_val) {
		if (typeof new_val !== "undefined")
			this._value = new_val;
		return (this._value);
	}

	setFormId(value) {
		if (value)
			this.formId = value;
		return (this.formId);
	}

	setQuestionId(value) {
		if (value)
			this.questionId = value;
		return (this.questionId);
	}

	get parentForm() {
		if (!this.parent)
			return (false);
		return (this.parent.parentForm);
	}

	get id() {
		return ((this.optionId ? this.optionId : this.tempId));
	}

	set id(value) {
		if (value)
			this.optionId = value;
	}
}
